module.exports = __webpack_public_path__ + "img/bootstrap-fill.f6977bde.svg";